// extracted by mini-css-extract-plugin
module.exports = {"container":"_2pPCOPdbSsAzZ_ARDa_sED","variant-white":"_2QPfOY-qmJGMMhQEUDs78-","variant-base":"_2omLqQaK4g5o1TshXw7PCl"};